<template>
  <div class="page-product-edit">
    <app-tips>温馨提示：确定需要投放的关键词后，才能进行发布“产品与服务”操作</app-tips>
    <div class="page-product-edit__content">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <app-page-box title="基础信息">
          <div class="page-product-edit__form-wrap">
            <el-form-item label="产品名称" prop="name" size="small">
              <el-input type="text" v-model="form.name" placeholder="请输入产品服务名称"></el-input>
            </el-form-item>
            <el-form-item label="产品分类" prop="category" size="small">
              <div class="page-product-edit__category">
                <el-select
                  value-key="id"
                  v-model="form.category"
                  :loading="selectLoading"
                  @change="handleCategoryChange"
                  @visible-change="handleSelectVisibleChange"
                  placeholder="请选择产品分类">
                  <el-option v-for="item in allCategories" :label="item.name" :value="item" :key="item.id"></el-option>
                </el-select>
                <el-button type="info" plain @click="showDialog">添加分类</el-button>
              </div>
            </el-form-item>
            <el-form-item label="主营业务" prop="mainBusinessId" size="small" style="width: 500px">
              <el-select
                value-key="id"
                v-model="form.mainBusinessId"
                placeholder="请选择主营业务"
                style="width: 100%;"
              >
                <el-option v-for="item in mainBusinesses" :label="item.label" :value="item.value" :key="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="产品摘要" prop="summary" size="small" style="width: 500px">
              <el-input type="textarea" v-model="form.summary" placeholder="请输入产品摘要10-125字"></el-input>
            </el-form-item>
            <el-form-item label="排序位置" prop="position" size="small">
              <el-input-number v-model="form.index" controls-position="right" :min="1" :max="100"></el-input-number>
            </el-form-item>
          </div>
        </app-page-box>
        <app-page-box title="图片信息" tip="为了保证页面的美观度，尽量上传2-3张产品封面图">
          <el-form-item label="产品主图" prop="imageList" size="small">
            <div class="page-product-edit__img">
              <app-image-uploader :images="images" @change="handleImagesChange"></app-image-uploader>
            </div>
            <p class="page-product-edit__tip">建议图片尺寸420px * 420px，格式为.png、.jpg以及.jpeg，大小1M以下，最多可以上传4张</p>
          </el-form-item>
        </app-page-box>
        <app-page-box title="描述信息" tip="产品描述尽量用图文排版布局，有利于快速排名">
          <el-form-item label="产品描述" prop="description" size="small">
            <sme-editor v-model="form.description" @input="handleEditorInput" placeholder="请输入产品产品描述"></sme-editor>
          </el-form-item>
          <el-form-item class="page-product-edit__submit" size="small">
            <el-button @click="handleBtnCancelClick">取消</el-button>
            <el-button type="primary" @click="handleOkBtnClick">确认发布</el-button>
          </el-form-item>
        </app-page-box>
      </el-form>
    </div>
    <el-dialog title="管理分类" :visible.sync="visible" :before-close="hideDialog">
      <app-category-manager></app-category-manager>
    </el-dialog>
  </div>
</template>

<script>
import AppPageBox from '@/components/AppPageBox'
import AppCategoryManager from './AppCategoryManager'
import AppImageUploader from '@/components/AppImageUploader'
import AppTips from '@/components/AppTips.vue'
import api from '@/api'

export default {
  name: 'ProductEdit',
  components: {
    AppPageBox,
    AppImageUploader,
    AppCategoryManager,
    AppTips
  },

  data () {
    return {
      options: [],
      selectLoading: false,
      visible: false,
      form: {
        id: undefined,
        name: '',
        category: {
          id: '',
          name: ''
        },
        mainBusinessId: '',
        summary: '',
        index: 1,
        imageList: [],
        description: ''
      },
      rules: {
        name: { required: true, message: '请输入产品名称', trigger: 'change' },
        category: {
          type: 'object',
          required: true,
          trigger: 'change',
          fields: {
            id: { type: 'number', message: '请选择产品分类' }
          }
        },
        mainBusinessId: { type: 'number', required: true, message: '请选择主营业务', trigger: 'change' },
        summary: [
          { required: true, message: '请输入文章摘要', trigger: 'change' },
          { min: 10, max: 125, message: '文章摘要：10-125字', trigger: 'change' }
        ],
        imageList: [
          { type: 'array', required: true, message: '请上传产品图片', trigger: 'manual' },
          { type: 'array', min: 2, max: 4, message: '产品主图：2-4张', trigger: 'change' }
        ],
        description: { required: true, message: '请输入产品描述', trigger: 'input' }
      },
      mainBusinesses: []
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },

    images () {
      const { showImage } = this.$options.filters
      return this.form.imageList.map((item, index) => {
        return {
          name: `pic-${index}`,
          url: showImage(item),
          response: { file_id: item }
        }
      })
    },

    allCategories () {
      return this.$store.state.category.allCategories
    }
  },

  created () {
    this.getCurrentProduct()
    this.getAllCategories()
    this.getKeywordPackages()
  },

  methods: {
    getAllCategories (cb) {
      this.$store.dispatch('getAllCategories', {
        params: { userId: this.user.id }
      }).then(response => {
        cb && cb(null, response.data)
      }).catch(error => {
        cb && cb(error)
      })
    },

    getCategories (cb) {
      this.$store.dispatch('getCategories', {
        params: { userId: this.user.id },
        query: {
          offset: 0,
          limit: 5
        }
      }).then(response => {
        cb && cb(null, response.data)
      }).catch(error => {
        cb && cb(error)
      })
    },

    // 获取词包信息
    getKeywordPackages () {
      api.keyword.getKeywordPackages({
        params: { userId: this.user.id }
      }).then(response => {
        const { data: { keywordPackageList } } = response
        this.mainBusinesses = keywordPackageList.map(item => ({
          label: item.name,
          value: item.id
        }))
      })
    },

    getCurrentProduct () {
      const productId = this.$route.query.id

      if (!productId) return

      this.$store.dispatch('getProductById', {
        params: {
          userId: this.user.id,
          productId: productId
        }
      }).then(response => {
        const { product } = response.data

        this.form.id = product.id
        this.form.name = product.name
        this.form.category = {
          id: product.categoryId,
          name: product.categoryName
        }
        this.form.mainBusinessId = product.mainBusinessId > 0 ? product.mainBusinessId : ''
        this.form.summary = product.summary
        this.form.index = product.index
        this.form.imageList = product.imageList
        this.form.description = product.description
      })
    },

    createProduct () {
      this.$store.dispatch('createProduct', {
        body: {
          product: {
            name: this.form.name,
            categoryId: this.form.category.id,
            mainBusinessId: this.form.mainBusinessId,
            summary: this.form.summary,
            index: this.form.index,
            imageList: this.form.imageList.filter(item => !!item),
            description: this.form.description,
            status: 0
          }
        },
        params: {
          userId: this.user.id
        }
      }).then(response => {
        this.$router.push({ name: 'ProductList' })
      })
    },

    updateProduct () {
      this.$store.dispatch('updateProduct', {
        body: {
          product: {
            name: this.form.name,
            categoryId: this.form.category.id,
            mainBusinessId: this.form.mainBusinessId,
            summary: this.form.summary,
            index: this.form.index,
            imageList: this.form.imageList,
            description: this.form.description
          }
        },
        params: {
          userId: this.user.id,
          productId: this.form.id
        }
      }).then(response => {
        this.$router.push({ name: 'ProductList' })
      })
    },

    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.updateProduct()
          } else {
            this.createProduct()
          }
        }
      })
    },

    handleCategoryChange (value) {
      console.log('[DEBUG] value', value)
    },

    handleSelectVisibleChange (visible) {
      if (visible) {
        this.selectLoading = true
        this.getAllCategories((error, data) => {
          this.selectLoading = false
          if (error) {
            console.log('[DEBUG] error', error)
          }
        })
      }
    },

    showDialog () {
      this.getCategories(() => {
        this.visible = true
      })
    },

    hideDialog () {
      this.visible = false
    },

    handleImagesChange (imageIds) {
      this.form.imageList = imageIds
      this.$refs.form.validateField('imageList')
    },

    handleEditorInput () {
      this.$refs.form.validateField('description')
    },

    handleBtnCancelClick () {
      this.$router.push({ name: 'ProductList' })
    },

    handleOkBtnClick () {
      this.submit()
    }

  }
}
</script>

<style lang="scss">
.page-product-edit {
  min-height: 100%;

  .el-form-item.is-required .el-form-item__label:before {
    font-family: sans-serif;
  }

  .app-page-box {
    margin-bottom: 0;
  }

  .el-dialog__body {
    padding: 10px 20px 20px;
  }

  &__content {
    margin-top: 15px;
    background-color: #fff;
  }

  &__form-wrap {
    width: 500px;
  }

  &__img {
    display: flex;
    justify-content: space-between;
  }

  &__tip {
    margin: 0;
    color: #999;
    font-size: 12px;
  }

  &__category {
    display: flex;

    .el-select {
      flex: 1;
    }

    .el-button {
      margin-left: 10px;
    }
  }

  &__submit {
    margin-top: 30px;
  }

}
</style>
